module.exports = __webpack_public_path__ + "static/media/155.3bb504dd.jpg";